<template>
  <div style="padding:15px">
    <a-form :form="form" @submit="onSubmit">
      <a-divider orientation="left">固定情報</a-divider>
      <a-card style="width: 100%;text-align:left;">
        <p style="padding:0px;margin:0px;">社員番号　：{{this.info.eid}}</p>
        <p style="padding:0px;margin:0px;">アカウント：{{this.info.user.account}}</p>
        <p style="padding:0px;margin:0px;">メール　　：{{this.info.user.email}}</p>
        <p style="padding:0px;margin:0px;">入社日付　：{{this.info.joined_at}}</p>
      </a-card>
      <a-divider orientation="left">基本情報</a-divider>
      <a-form-item v-bind="formItemLayout">
        <a-input
          size="small"
          v-decorator="['employee.user.userinfo.lastname']"
          :disabled="!canEditName"
          addonBefore="姓"
        />
      </a-form-item>
      <a-form-item v-bind="formItemLayout">
        <a-input
          size="small"
          v-decorator="['employee.user.userinfo.firstname']"
          :disabled="!canEditName"
          addonBefore="名"
        />
      </a-form-item>

      <a-form-item v-bind="formItemLayout" label="性別">
        <a-radio-group
          v-decorator="['employee.user.userinfo.sex']"
          :options="sex_options"
          style="float:left"
        />
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="誕生日">
        <a-date-picker
          :allowClear="false"
          v-decorator="['employee.user.userinfo.birthday']"
          format="YYYY-MM-DD"
          style="float:left"
          placeholder="未設定"
        />
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="郵便番号">
        <a-form-item :style="{ display: 'inline-block', width: 'calc(30%)' }">
          <a-input
            size="small"
            v-decorator="['employee.user.userinfo.pcode_1',{rules:[maxLen3Rule]}]"
            style="width: 100%"
          />
        </a-form-item>
        <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }">-</span>
        <a-form-item :style="{ display: 'inline-block', width: 'calc(50%)' }">
          <a-input
            size="small"
            v-decorator="['employee.user.userinfo.pcode_2',{rules:[maxLen4Rule]}]"
          />
        </a-form-item>
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="住所">
        <a-input size="small" v-decorator="['employee.user.userinfo.address']" placeholder="未設定"/>
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="携帯">
        <a-input
          size="small"
          v-decorator="['employee.user.userinfo.telphone',{rules:[phoneNumRule]}]"
          placeholder="未設定"
        />
      </a-form-item>
      <a-divider orientation="left">緊急連絡先</a-divider>
      <a-form-item v-bind="formItemLayout" label="関係">
        <a-input
          size="small"
          v-decorator="['employee.employeeinfo.emergency_contact_relation',{rules:[maxLen4Rule]}]"
          placeholder="未設定"
        />
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="名前">
        <a-input
          size="small"
          v-decorator="['employee.employeeinfo.emergency_contact_name',{rules:[maxLen25Rule]}]"
          placeholder="未設定"
        />
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="携帯">
        <a-input
          size="small"
          maxlength="25"
          v-decorator="['employee.employeeinfo.emergency_contact_telphone',{rules:[phoneNumRule]}]"
          placeholder="未設定"
        />
      </a-form-item>
      <a-divider orientation="left">ビザ情報</a-divider>
      <a-form-item v-bind="formItemLayout" label="在留期限">
        <a-date-picker
          :allowClear="false"
          v-decorator="['employee.employeeinfo.residence_card_expired']"
          format="YYYY-MM-DD"
          style="float:left"
          placeholder="未設定"
        />
      </a-form-item>

      <a-form-item v-bind="formItemLayout" label="パスポート">
        <a-date-picker
          :allowClear="false"
          v-decorator="['employee.employeeinfo.passport_expired']"
          format="YYYY-MM-DD"
          style="float:left"
          placeholder="未設定"
        />
      </a-form-item>

      <a-form-item>
        <a-button  :loading="isLoading"  style="float:left;margin:10px 10px;" type="primary" html-type="submit">update</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
const sex_options = [
  {
    label: "女",
    value: "female"
  },
  {
    label: "男",
    value: "male"
  },
  {
    label: "未設定",
    value: "unknown"
  }
];
export default {
  name: "EditInfo",
  props: ["info", "canEditName"],
  created() {
    if (!this.info) {
      return this.$router.push({ path: "/" });
    }
    this.editinfo = JSON.parse(JSON.stringify(this.info));
    if (this.editinfo.user.userinfo.postal_code) {
      this.editinfo.user.userinfo.pcode_1 = this.editinfo.user.userinfo.postal_code.split(
        "-"
      )[0];
      this.editinfo.user.userinfo.pcode_2 = this.editinfo.user.userinfo.postal_code.split(
        "-"
      )[1];
    }
    this.$logger.d("EditInfo", "created", {
      editinfo: this.editinfo
    });
    this.form = this.$form.createForm(this, {
      onFieldsChange: (_, changedFields) => {
        this.$logger.d("EditInfo", "onFieldsChange", {
          changedFields: changedFields
        });
        this.$emit("change", changedFields);
      },
      mapPropsToFields: () => {
        return {
          employee: {
            eid: this.$form.createFormField({
              value: this.editinfo.eid
            }),
            joined_at: this.$form.createFormField({
              value: this.$moment(this.editinfo.joined_at, "YYYY/MM/DD")
            }),
            employeeinfo: {
              residence_card_expired: this.$form.createFormField({
                value: this.editinfo.employeeinfo.residence_card_expired
                  ? this.$moment(
                      this.editinfo.employeeinfo.residence_card_expired,
                      "YYYY/MM/DD"
                    )
                  : null
              }),
              passport_expired: this.$form.createFormField({
                value: this.editinfo.employeeinfo.passport_expired
                  ? this.$moment(
                      this.editinfo.employeeinfo.passport_expired,
                      "YYYY/MM/DD"
                    )
                  : null
              }),
              emergency_contact_relation: this.$form.createFormField({
                value: this.editinfo.employeeinfo.emergency_contact_relation
              }),
              emergency_contact_name: this.$form.createFormField({
                value: this.editinfo.employeeinfo.emergency_contact_name
              }),
              emergency_contact_telphone: this.$form.createFormField({
                value: this.editinfo.employeeinfo.emergency_contact_telphone
              })
            },
            user: {
              account: this.$form.createFormField({
                value: this.editinfo.user.account
              }),
              email: this.$form.createFormField({
                value: this.editinfo.user.email
              }),
              userinfo: {
                lastname: this.$form.createFormField({
                  value: this.editinfo.user.userinfo.lastname
                }),
                firstname: this.$form.createFormField({
                  value: this.editinfo.user.userinfo.firstname
                }),
                sex: this.$form.createFormField({
                  value: this.editinfo.user.userinfo.sex
                }),
                birthday: this.$form.createFormField({
                  value: this.editinfo.user.userinfo.birthday
                    ? this.$moment(
                        this.editinfo.user.userinfo.birthday,
                        "YYYY/MM/DD"
                      )
                    : null
                }),
                address: this.$form.createFormField({
                  value: this.editinfo.user.userinfo.address
                }),
                telphone: this.$form.createFormField({
                  value: this.editinfo.user.userinfo.telphone
                }),
                pcode_1: this.$form.createFormField({
                  value: this.editinfo.user.userinfo.pcode_1
                }),
                pcode_2: this.$form.createFormField({
                  value: this.editinfo.user.userinfo.pcode_2
                })
              }
            }
          }
        };
      },
      onValuesChange: (_, values) => {
        this.$logger.d("EditInfo", "onValuesChange", {
          values: values
        });
      }
    });
  },
  data() {
    return {
      sex_options,
      isLoading:false,
      formItemLayout: {
        wrapperCol: {
          span: 18
        }
      },
      numberRule: {
        type: "string",
        pattern: /^[0-9]*$/,
        message: "must be number!"
      },
      minLen5Rule: {
        type: "string",
        min: 5,
        message: "length min:5"
      },
      maxLen3Rule: {
        type: "string",
        max: 3,
        message: "length max:3"
      },
      maxLen4Rule: {
        type: "string",
        max: 4,
        message: "length max:4"
      },
      maxLen25Rule: {
        type: "string",
        max: 25,
        message: "length max:25"
      },
      phoneNumRule: {
        type: "string",
        pattern: /^[0-9]*$/,
        max: 11,
        message: "length must be phone number!"
      },
      dateRule: {
        type: "date",
        message: "must be date!"
      },
      editinfo: null
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      
      this.form.validateFields((err, values) => {
        if (!err) {
          
          if (
            values.employee.user.userinfo.pcode_1 &&
            values.employee.user.userinfo.pcode_2
          ) {
            values.employee.user.userinfo.postal_code =
              values.employee.user.userinfo.pcode_1 +
              "-" +
              values.employee.user.userinfo.pcode_2;
          }

          if(values.employee.user.userinfo.birthday){
            values.employee.user.userinfo.birthday = values.employee.user.userinfo.birthday.format('YYYY/MM/DD')
          }
          if(values.employee.employeeinfo.residence_card_expired){
            values.employee.employeeinfo.residence_card_expired = values.employee.employeeinfo.residence_card_expired.format('YYYY/MM/DD')
          }
          if(values.employee.employeeinfo.passport_expired){
            values.employee.employeeinfo.passport_expired = values.employee.employeeinfo.passport_expired.format('YYYY/MM/DD')
          }
          this.$logger.d("EditInfo", "onSubmit", {
            err: err,
            values: values,
            eid: this.info.eid
          });
          
          this.isLoading=true
          let token = this.$store.getters.token;
          this.$api.employee
            .update({
              token: token,
              eid: this.info.eid,
              userinfo: values.employee.user.userinfo,
              employeeinfo: values.employee.employeeinfo
            })
            .then(data => {
              let resp = data.data;
              this.isLoading = false;
              this.$logger.d("EditInfo", "api.employee.update", {
                response: resp
              });
              if (resp.error) {
                // this.$notification.error({
                //   message:"エラー:"+resp.error.code,
                //   description:resp.error.description}
                // );
                this.$error_handler(this,resp.error)
              } else {
                this.$notification.success({
                  message:"更新完了しました"
                })
              }
            })
            .catch(err => {
              this.$logger.e("EditInfo", "api.employee.update", {
                error: err
              });
              this.$notification.error({
                message:"エラー",
                description:"サーバ通信エラー"});
              this.isLoading = false;
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.ant-form-item {
  margin: 0 0;
}
</style>
